import { app } from '../../../../app';
import { Controller } from './shared-inner-menu.controller';

app.component('companySharingCenterManage', {
    bindings: {
		companyId: '<',
		isNote: '<',
		sharedAccount:'<',
        sharedAccountId: '<'
    },
    controller: Controller,
    templateUrl: require('./shared-inner-menu.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-inner-menu/shared-inner-menu.component.js